(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("user-agents", [], factory);
	else if(typeof exports === 'object')
		exports["user-agents"] = factory();
	else
		root["user-agents"] = factory();
})(global, function() {
return 